import React from 'react';
import CtafromSection from '../CtafromSection/CtafromSection'


const Contactpage = () => {

    return (
        <>
        <section className="wpo-contact-pg-section section-padding">
            <div className="container">
                <div className="row">
                    <div className="col col-lg-10 offset-lg-1">
                        <div className="wpo-contact-title">
                            <h2 style={{fontSize: '48px', fontWeight: '600', color: '#2c3e50', marginBottom: '25px', lineHeight: '1.3'}}>
                                Schedule Your Consultation at <span style={{color: '#0066cc'}}>Amped Therapeutics</span>
                            </h2>
                            <p style={{fontSize: '18px', lineHeight: '1.8', color: '#555', marginBottom: '30px'}}>
                                Our expert medical team is ready to help you explore advanced stem cell therapy options. 
                                Our state-of-the-art facility combines cutting-edge technology with compassionate care 
                                to deliver transformative results for patients throughout Florida.
                            </p>
                            <div style={{
                                background: '#f8f9fa',
                                padding: '50px 0',
                                marginTop: '40px',
                                marginLeft: 'calc(-50vw + 50%)',
                                marginRight: 'calc(-50vw + 50%)',
                                boxShadow: '0 5px 20px rgba(0,0,0,0.08)'
                            }}>
                                <p style={{
                                    fontSize: '24px',
                                    fontWeight: '600',
                                    color: '#2c3e50',
                                    marginBottom: '25px',
                                    textAlign: 'center'
                                }}>
                                    Consultation Includes
                                </p>
                                <div style={{
                                    display: 'grid',
                                    gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
                                    gap: '20px',
                                    maxWidth: '1200px',
                                    margin: '0 auto',
                                    padding: '0 20px'
                                }}>
                                    <div style={{
                                        background: 'rgba(255,255,255,0.95)',
                                        padding: '20px',
                                        borderRadius: '15px',
                                        display: 'flex',
                                        alignItems: 'flex-start',
                                        cursor: 'default'
                                    }}>
                                        <span style={{
                                            background: '#0066cc',
                                            color: '#fff',
                                            width: '30px',
                                            height: '30px',
                                            minWidth: '30px',
                                            borderRadius: '50%',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            marginRight: '15px',
                                            marginTop: '0',
                                            fontSize: '18px',
                                            fontWeight: 'bold'
                                        }}>✓</span>
                                        <span style={{color: '#333', fontSize: '16px'}}>Tour our advanced stem cell processing facility</span>
                                    </div>
                                    <div style={{
                                        background: 'rgba(255,255,255,0.95)',
                                        padding: '20px',
                                        borderRadius: '15px',
                                        display: 'flex',
                                        alignItems: 'flex-start',
                                        cursor: 'default'
                                    }}>
                                        <span style={{
                                            background: '#0066cc',
                                            color: '#fff',
                                            width: '30px',
                                            height: '30px',
                                            minWidth: '30px',
                                            borderRadius: '50%',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            marginRight: '15px',
                                            marginTop: '0',
                                            fontSize: '18px',
                                            fontWeight: 'bold'
                                        }}>✓</span>
                                        <span style={{color: '#333', fontSize: '16px'}}>Meet with our medical team</span>
                                    </div>
                                    <div style={{
                                        background: 'rgba(255,255,255,0.95)',
                                        padding: '20px',
                                        borderRadius: '15px',
                                        display: 'flex',
                                        alignItems: 'flex-start',
                                        cursor: 'default'
                                    }}>
                                        <span style={{
                                            background: '#0066cc',
                                            color: '#fff',
                                            width: '30px',
                                            height: '30px',
                                            minWidth: '30px',
                                            borderRadius: '50%',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            marginRight: '15px',
                                            marginTop: '0',
                                            fontSize: '18px',
                                            fontWeight: 'bold'
                                        }}>✓</span>
                                        <span style={{color: '#333', fontSize: '16px'}}>Comprehensive health evaluation</span>
                                    </div>
                                    <div style={{
                                        background: 'rgba(255,255,255,0.95)',
                                        padding: '20px',
                                        borderRadius: '15px',
                                        display: 'flex',
                                        alignItems: 'flex-start',
                                        cursor: 'default'
                                    }}>
                                        <span style={{
                                            background: '#0066cc',
                                            color: '#fff',
                                            width: '30px',
                                            height: '30px',
                                            minWidth: '30px',
                                            borderRadius: '50%',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            marginRight: '15px',
                                            marginTop: '0',
                                            fontSize: '18px',
                                            fontWeight: 'bold'
                                        }}>✓</span>
                                        <span style={{color: '#333', fontSize: '16px'}}>Personalized stem cell treatment planning</span>
                                    </div>
                                    <div style={{
                                        background: 'rgba(255,255,255,0.95)',
                                        padding: '20px',
                                        borderRadius: '15px',
                                        display: 'flex',
                                        alignItems: 'flex-start',
                                        cursor: 'default'
                                    }}>
                                        <span style={{
                                            background: '#0066cc',
                                            color: '#fff',
                                            width: '30px',
                                            height: '30px',
                                            minWidth: '30px',
                                            borderRadius: '50%',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            marginRight: '15px',
                                            marginTop: '0',
                                            fontSize: '18px',
                                            fontWeight: 'bold'
                                        }}>✓</span>
                                        <span style={{color: '#333', fontSize: '16px'}}>Review of clinical protocols and safety measures</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <CtafromSection hclass={'ctafrom_section'} />
    </>
    )

}

export default Contactpage;
